module.exports = __webpack_public_path__ + "img/jn.fd8904bc.jpg";